import { Box, Typography } from '@mui/material';
import { useBlockPurchaseFlag } from '~/hooks/useBlockPurchaseFlag';

import Banner from '../components/banner';

export default function BlockPurchaseBanner() {
  const { useBlockPurchase } = useBlockPurchaseFlag();

  if (useBlockPurchase) {
    return (
      <Banner isCritical>
        <Box width="100%">
          <Typography component="span" variant="body1" fontWeight="bold">
            All purchasing (including Combines & Resets) will be temporarily disabled for 15 minutes
            for maintenance. Please try again at that time.
          </Typography>
        </Box>
      </Banner>
    );
  }

  return <></>;
}
